module.exports = __webpack_public_path__ + "media/assets/icons/hokenryo-icon-867b59ea35c8033d1c08ce2982b73a59.svg";